import styled, {css} from 'styled-components'
import {Item, Root} from '@radix-ui/react-toggle-group'

export const StyledToggleGroupEntityRoot = styled(Root)(
    ({theme: {palette, typography, spacing}}) => css`
        ${typography.textXs};
        display: flex;
        width: 100%;
        background-color: ${palette.neutral['white']};
        border-top: 1px solid ${palette.neutral['200']};
        padding: ${spacing * 2}px;
        gap: ${spacing * 2}px;
    `
)

export const StyledToggleGroupEntityItem = styled(Item)(
    ({theme: {palette, spacing}}) => css`
        padding: ${spacing}px;
        min-width: 60px;
        text-align: center;
        cursor: pointer;
        color: ${palette.neutral['600']};
        background-color: ${palette.neutral['100']};
        border: 1px solid ${palette.neutral['200']};
        font-weight: 500;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;

        &[data-state='on'] {
            background-color: ${palette.primary['50']};
            color: ${palette.primary['600']};
            border: 1px solid ${palette.primary['200']};
        }
    `
)
